import { Component, Input, OnInit } from '@angular/core';
import { ConfigFacadeService } from '@core/services/config/config-facade.service';
import { RadioItem } from '@app/interfaces';
import { SettingsService } from '@app/services/settings.service';
import { clonedeep } from '@utils/helpers';

@Component({
	selector: 'app-admin-modal-permissions',
	templateUrl: './admin-modal-permissions.component.html',
	styleUrls: ['./admin-modal-permissions.component.scss'],
})
export class AdminModalPermissionsComponent implements OnInit {
	@Input() data: any;
	isCollapsed: any[] = [];
	services_map: any;
	jsonTemplate: any;
	radio_btn_items: RadioItem[] = [
		{
			name: 'Read only',
			value: 'radioReadOnlyMode',
		},
		{
			name: 'Managed',
			value: 'radioAllModules',
		},
	];
	radioSel: any;
	radioSelected: string;
	radioSelectedString: string;
	permissions_radio_selected: string;
	permissions = [];
	permissions_to_be = {};
	permissions_to_fe = {};
	translate_dict = {};
	jsonFile = {};
	services_names = [];
	services_lists = {};

	constructor(private setupService: SettingsService, private appConfig: ConfigFacadeService) {
		setTimeout(() => {
			const permissions = Object.keys(this.data);
			this.loadExistingAccountPermissions(permissions);

			this.radioSelected = 'radioAllModules';
			this.permissions_radio_selected = 'Managed';
			this.getSelecteditem();
		}, 500);
	}

	clearPermissions() {
		const keys = Object.keys(this.permissions_to_be);
		keys.forEach((key) => {
			this.permissions_to_be[key] = [];
			this.permissions_to_fe[key] = { list_read: [], write: [] };
		});
	}

	loadExistingAccountPermissions(permissions) {
		this.clearPermissions();
		this.services_names.forEach((element) => {
			this.services_lists[element.name] = Object.keys(this.services_map[element.name]['AWS']['Services']);
		});

		permissions.forEach((permission) => {
			const splitted_permission = permission.split(':');
			if (this.permissions_to_be[this.translate_dict[splitted_permission[0]]] !== undefined) {
				this.permissions_to_be[this.translate_dict[splitted_permission[0]]].push(permission);
			}
		});

		this.services_names.forEach((element) => {
			this.services_lists[element.name] = Object.keys(this.services_map[element.name]['AWS']['Services']);
			this.services_lists[element.name].forEach((service) => {
				if (
					this.services_map[element.name]['options']['default'] &&
					this.services_map[element.name]['options']['permanent']
				) {
					if (this.services_map[element.name]['AWS']['Services'][service]['list'].length > 0) {
						this.services_map[element.name]['AWS']['Services'][service]['list'].forEach((item) => {
							if (!this.permissions_to_be[service].includes(item)) {
								this.permissions_to_be[service].push(item);
							}
						});
					}
					if (this.services_map[element.name]['AWS']['Services'][service]['read'].length > 0) {
						this.services_map[element.name]['AWS']['Services'][service]['read'].forEach((item) => {
							if (!this.permissions_to_be[service].includes(item)) {
								this.permissions_to_be[service].push(item);
							}
						});
					}
					if (this.services_map[element.name]['AWS']['Services'][service]['write_mandatory'].length > 0) {
						this.services_map[element.name]['AWS']['Services'][service]['write_mandatory'].forEach((item) => {
							if (!this.permissions_to_be[service].includes(item)) {
								this.permissions_to_be[service].push(item);
							}
						});
					}
				}

				const list = this.services_map[element.name]['AWS']['Services'][service]['list'].some(
					(r) => this.permissions_to_be[service].indexOf(r) >= 0,
				);
				if (list) {
					this.services_map[element.name]['AWS']['Services'][service]['list'].forEach((item) => {
						if (!this.permissions_to_be[service].includes(item)) {
							this.permissions_to_be[service].push(item);
						}
					});
				}

				const read = this.services_map[element.name]['AWS']['Services'][service]['read'].some(
					(r) => this.permissions_to_be[service].indexOf(r) >= 0,
				);
				if (read) {
					this.services_map[element.name]['AWS']['Services'][service]['read'].forEach((item) => {
						if (!this.permissions_to_be[service].includes(item)) {
							this.permissions_to_be[service].push(item);
						}
					});
				}

				const write_mandatory = this.services_map[element.name]['AWS']['Services'][service]['write_mandatory'].some(
					(r) => this.permissions_to_be[service].indexOf(r) >= 0,
				);
				if (write_mandatory) {
					this.services_map[element.name]['AWS']['Services'][service]['write_mandatory'].forEach((item) => {
						if (!this.permissions_to_be[service].includes(item)) {
							this.permissions_to_be[service].push(item);
						}
					});
				}
			});
		});
	}

	getSelecteditem() {
		this.radioSel = this.radio_btn_items.find((Item) => Item.value === this.radioSelected);
		this.radioSelectedString = JSON.stringify(this.radioSel);
	}

	capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	updateJson() {
		// @Todo: check cloudvisor OR zesty?
		const label = this.capitalizeFirstLetter(this.appConfig.config.partner.prefix);
		this.jsonFile = {};
		this.jsonFile = clonedeep(this.jsonTemplate);
		this.permissions.forEach((service) => {
			const statement = {
				Sid: label + service.replace(/\s/g, '') + 'Access',
				Effect: 'Allow',
				Action: [],
				Resource: ['*'],
			};
			if (this.permissions_to_be[service] != null && this.permissions_to_be[service].length > 0) {
				this.permissions_to_be[service].forEach((permission) => {
					statement['Action'].push(permission);
				});
				this.jsonFile['Resources'][label + 'IamRole']['Properties']['Policies'][0]['PolicyDocument']['Statement'].push(
					statement,
				);
			}
		});
	}

	checkIfServiceHaveActivePerm(cv_service) {
		const amazonServicesNames = Object.keys(this.services_map[cv_service]['AWS']['Services']);
		const actions = ['list', 'read', 'write_opt', 'write_mandatory'];
		let active = false;
		amazonServicesNames.forEach((service) => {
			actions.forEach((action) => {
				const found = this.services_map[cv_service]['AWS']['Services'][service][action].some(
					(r) => this.permissions_to_be[service].indexOf(r) >= 0,
				);
				if (found) {
					active = found;
				}
			});
		});
		return active;
	}

	checkIfActionHaveActivePerm(cv_service, service, action) {
		const found = this.services_map[cv_service]['AWS']['Services'][service][action].some(
			(r) => this.permissions_to_be[service].indexOf(r) >= 0,
		);
		return found;
	}

	ngOnInit() {
		this.updateJson();
		try {
			const response = this.setupService.getTemplateAndPermissionsMap(this.appConfig.config.partner.prefix);
			response.subscribe((val) => {
				this.services_map = val['permissions_map'];
				this.jsonTemplate = val['template'];

				// Sorting the services by order
				Object.keys(this.services_map).forEach((service) => {
					this.services_names.push({
						name: service,
						order: this.services_map[service]['options']['order'],
					});
				});

				this.services_names.sort((a, b) => {
					if (a.order < b.order) {
						return -1;
					}
					if (a.order > b.order) {
						return 1;
					}
					return 0;
				});

				const cv_services = Object.keys(this.services_map);
				cv_services.forEach((cv_service) => {
					const translate_keys = Object.keys(this.services_map[cv_service]['options']['translate']);
					translate_keys.forEach((key) => {
						this.translate_dict[key] = this.services_map[cv_service]['options']['translate'][key];
					});

					const services = Object.keys(this.services_map[cv_service]['AWS']['Services']);
					services.forEach((service) => {
						if (this.permissions_to_be[service] === undefined) {
							this.permissions_to_be[service] = [];
						}
						if (this.permissions_to_fe[service] === undefined) {
							this.permissions_to_fe[service] = { list_read: [], write: [] };
						}
					});
				});
				this.permissions = Object.keys(this.permissions_to_be);
			});
		} catch {
			console.error('error...');
		}
	}
}
